import { AxiosError } from 'axios';
import { HttpStatusCodes } from '../HttpStatusCodes';
import { ErrorStatusResponse } from './Types';

const PREFERENCE_FILTER_NAME_VALIDATION_ERROR_MESSAGE: string = 'Name already exists';
const PREFERENCE_VALIDATION_ERROR_MESSAGE: string = 'Key already exists';
const PREFERENCE_NOT_FOUND_ERROR_MESSAGE = (id: string) => `Preference #${id} not found`;
const PREFERENCE_FILTER_NOT_FOUND_ERROR_MESSAGE: (id: string) => string = (id: string) => `Filter #${id} not found`;

/**
 *@return boolean
 *
 * @remarks
 * check if the response error http code is 422 and message is non-unique key message
 *
 * @param e - AxiosError
 * **/
export const isValidationError = (e: AxiosError<ErrorStatusResponse>): boolean => {
  return (
    e?.response?.data?.statusCode === HttpStatusCodes.UNPROCESSABLE_ENTITY &&
    (e?.response?.data?.message === PREFERENCE_VALIDATION_ERROR_MESSAGE ||
      e?.response?.data?.message === PREFERENCE_FILTER_NAME_VALIDATION_ERROR_MESSAGE)
  );
};

/**
 *@return boolean
 *
 * @remarks
 * check if the response error http code is 404 and message is preference if not found
 *
 * @param e - AxiosError
 * @param id - preference data id
 * **/
export const isNotFoundError = (e: AxiosError<ErrorStatusResponse>, id: string): boolean => {
  return (
    e?.response?.data?.statusCode === HttpStatusCodes.NOT_FOUND &&
    (e?.response.data?.message === PREFERENCE_NOT_FOUND_ERROR_MESSAGE(id) ||
      e?.response.data?.message === PREFERENCE_FILTER_NOT_FOUND_ERROR_MESSAGE(id))
  );
};
